import CryptoJS from "crypto-js";

// Base key (obfuscated)
const RAW_KEY = process.env.REACT_APP_LOGINATTEMPT_KEY;
const BASE_STORAGE_KEY = CryptoJS.MD5(RAW_KEY).toString();
const MAX_ATTEMPTS = process.env.REACT_APP_LOGINATTEMPT_MAX;
const BLOCK_DURATION = process.env.REACT_APP_LOGINATTEMPT * 60 * 1000;
const RESET_TIME = process.env.REACT_APP_LOGINATTEMPT_RESET * 60 * 1000;
const ATTEMPT_SCRETE = process.env.REACT_APP_LOGINATTEMPT_SECRETE;

// 🚀 Generate a pseudo Device ID using browser fingerprint
function getDeviceKey() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "unknown-tz";
  const screenRes = `${window.screen.width}x${window.screen.height}` || "unknown-screen";
  const language = navigator.languages ? navigator.languages[0] : "unknown-lang";
  const cpuCores = navigator.hardwareConcurrency || "unknown-cores";
  const ram = navigator.deviceMemory || "unknown-ram";

  // Combine all parts
  const deviceRaw = `${timezone}|${screenRes}|${language}|cpu-${cpuCores}|ram-${ram}`;

  // Hash it for obfuscation
  return CryptoJS.MD5(deviceRaw).toString();
}

// Final key tied to device
export function getStorageKey() {
  return `${BASE_STORAGE_KEY}_${getDeviceKey()}`;
}

// 🔐 Load attempt data from localStorage
export function loadAttemptData(storageKey) {
  try {
    const encryptedData = localStorage.getItem(storageKey);
    if (encryptedData) {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, ATTEMPT_SCRETE);
      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedText);
    }
    return null;
  } catch (err) {
    console.error("Error loading attempt data:", err);
    return null;
  }
}

// 🔐 Save attempt data to localStorage
function saveAttemptData(data, storageKey) {
  try {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      ATTEMPT_SCRETE
    ).toString();
    localStorage.setItem(storageKey, encryptedData);
  } catch (err) {
    console.error("Error saving attempt data:", err);
  }
}

// 🚨 Handle Login Attempt Logic
export function handleLoginAttempt() {
  const now = Date.now();
  const storageKey = getStorageKey();

  let attemptData = loadAttemptData(storageKey) || {
    attemptCount: 0,
    blockedUntil: null,
    lastAttempt: null,
  };

  // ✅ Check if currently blocked
  if (attemptData.blockedUntil && now < attemptData.blockedUntil) {
    console.warn("User is blocked until:", new Date(attemptData.blockedUntil));
    alert(`🚫 You are blocked! Try again after ${new Date(attemptData.blockedUntil).toLocaleTimeString()}`);
    return false; // Stop further attempts
  }

  // ✅ Reset attempt count if time gap > RESET_TIME
  if (attemptData.lastAttempt && now - attemptData.lastAttempt > RESET_TIME) {
    attemptData.attemptCount = 1; // Reset and start fresh
  } else {
    attemptData.attemptCount += 1; // Increment normally
  }

  // ✅ Update last attempt timestamp
  attemptData.lastAttempt = now;

  // ✅ Check if user should be blocked
  if (attemptData.attemptCount >= MAX_ATTEMPTS) {
    attemptData.blockedUntil = now + BLOCK_DURATION;
    console.warn(
      `Too many failed attempts. User blocked until ${new Date(
        attemptData.blockedUntil
      ).toLocaleTimeString()}`
    );
    saveAttemptData(attemptData, storageKey);
    window.location.reload(); // Optional: Refresh UI to show block
    return false;
  }

  // 🔐 Save updated data
  saveAttemptData(attemptData, storageKey);
  return true; // Allow API attempt
}
